import * as React from "react";
import "./FAQPage.css";
import Collapse from "rc-collapse";
import Flex from "../../components/Flex/Flex";
import Text from "../../components/Text/Text";
import CaretDownIcon from "../../assets/Icons/CaretDownIcon.svg?react";
import classNames from "classnames";
import motion from "../../utils/motionUtil.ts";
import preflop from "../../assets/preflop.png";
import postflop from "../../assets/postflop.png";
import portable1 from "../../assets/portable1.png";
import portable2 from "../../assets/portable2.png";
import portable3 from "../../assets/portable3.png";
import bookmode1 from "../../assets/bookmode1.png";
import bookmode2 from "../../assets/bookmode2.png";
import bookmode3 from "../../assets/bookmode3.png";
import randomizer1 from "../../assets/randomizer1.png";
import randomizer2 from "../../assets/randomizer2.png";
import randomizer3 from "../../assets/randomizer3.png";
import starscaption from "../../assets/starscaption.png";
import jurojin1 from "../../assets/jurojin1.png";
import jurojin2 from "../../assets/jurojin2.png";
import jurojin3 from "../../assets/jurojin3.png";
import jurojin4 from "../../assets/jurojin4.png";
import { useTranslation } from "react-i18next";

const FAQPage = React.memo(() => {
  const { t } = useTranslation("translation");

  const expandIcon = ({ isActive }: any) => {
    return (
      <i
        className={classNames("FAQPage__Collapse-icon", {
          "FAQPage__Collapse-icon--active": isActive,
        })}
      >
        <CaretDownIcon />
      </i>
    );
  };

  const items = [
    {
      label: <Text size={4}>{t("faq_panel1_title")}</Text>,
      children: (
        <Flex
          vertical
          gap={24}
        >
          <Flex justify="space-between">
            <div>
              <img src={preflop} />
            </div>
            <div>
              <img src={postflop} />
            </div>
          </Flex>
          <Flex
            vertical
            gap={8}
          >
            <Text size={3}>
              <b>SQZ</b> – Squeeze
            </Text>
            <Text size={3}>
              <b>CC</b> – cold call preflop
            </Text>
            <Text size={3}>
              <b>FvBet</b> – Fold To bet
            </Text>
            <Text size={3}>
              <b>Rbet</b> – Raise Bet
            </Text>
            <Text size={3}>
              <b>Cbet</b> – Raise Bet
            </Text>
            <Text size={3}>
              <b>FvCb</b> – Fold vs Continuation bet
            </Text>
            <Text size={3}>
              <b>RCb</b> – Raise Continuation bet
            </Text>
            <Text size={3}>
              <b>Agf%</b> - Aggression frequency
            </Text>
          </Flex>
        </Flex>
      ),
    },
    {
      label: <Text size={4}>{t("faq_panel2_title")}</Text>,
      children: (
        <Flex
          vertical
          gap={32}
        >
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel2_content1")}</Text>
            <div>
              <img src={portable1} />
            </div>
          </Flex>
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel2_content2")}</Text>
            <img src={portable2} />
          </Flex>

          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>
              {t("faq_panel2_content3_1")}
              <b>{t("faq_panel2_content3_2")}</b>
            </Text>
            <div>
              <img src={portable3} />
            </div>
          </Flex>
        </Flex>
      ),
    },
    {
      label: <Text size={4}>{t("faq_panel3_title")}</Text>,
      children: (
        <Flex
          vertical
          gap={32}
        >
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel3_content1")}</Text>
            <div>
              <img src={bookmode1} />
            </div>
          </Flex>
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel3_content2")}</Text>
            <Flex gap={24}>
              <img src={bookmode2} />
              <div>
                <img src={bookmode3} />
              </div>
            </Flex>
          </Flex>
        </Flex>
      ),
    },
    {
      label: <Text size={4}>{t("faq_panel4_title")}</Text>,
      children: (
        <Flex
          vertical
          gap={32}
        >
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel4_content1")}</Text>
            <div>
              <img src={randomizer1} />
            </div>
          </Flex>
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel4_content2")}</Text>
            <Flex gap={24}>
              <div>
                <img src={randomizer2} />
              </div>
              <div>
                <img src={randomizer3} />
              </div>
            </Flex>
          </Flex>
        </Flex>
      ),
    },
    {
      label: <Text size={4}>{t("faq_panel5_title1")}</Text>,
      children: (
        <Flex
          vertical
          gap={32}
        >
          <Flex
            vertical
            gap={24}
          >
            <Text
              size={3}
              bold
            >
              {t("faq_panel5_title2")}
            </Text>
            <Flex
              vertical
              gap={16}
            >
              <Flex vertical>
                <Text size={3}>{t("faq_panel5_content1")}</Text>
                <Text
                  size={3}
                  type="primary"
                  underline
                >
                  http://fishhunter.info/statistics?playername=[SCREENNAME]&room=ps
                </Text>
              </Flex>
              <Flex vertical>
                <Text size={3}>{t("faq_panel5_content2")}</Text>
                <Text
                  size={3}
                  type="primary"
                  underline
                >
                  http://fishhunter.info/statistics?playername=[SCREENNAME]&room=888
                </Text>
              </Flex>
            </Flex>
            <Flex vertical>
              <Text size={3}>{t("faq_panel5_content3")}</Text>
              <img
                src={starscaption}
                className="FAQPage__Collapse-image"
              />
            </Flex>
          </Flex>
          <Flex
            vertical
            gap={24}
          >
            <Flex vertical>
              <Text
                size={3}
                bold
              >
                {t("faq_panel5_title3")}
              </Text>
              <Text size={3}>{t("faq_panel5_content4")}</Text>
            </Flex>
            <Flex
              vertical
              gap={16}
            >
              <Flex vertical>
                <Text size={3}>{t("faq_panel5_content5")}</Text>
                <img
                  src={jurojin1}
                  className="FAQPage__Collapse-image"
                />
              </Flex>
              <Flex vertical>
                <Text size={3}>
                  {t("faq_panel5_content6_1")}
                  <b>{t("faq_panel5_content6_2")}</b>
                </Text>
                <Text
                  size={3}
                  type="primary"
                  underline
                >
                  {
                    "https://fishhunter.info/statistics?playername=<PLAYER>&room=chi"
                  }
                </Text>
              </Flex>
              <Flex vertical>
                <img
                  src={jurojin2}
                  className="FAQPage__Collapse-image"
                />
              </Flex>
              <Text size={3}>{t("faq_panel5_content7")}</Text>
            </Flex>
          </Flex>
          <Flex
            vertical
            gap={16}
          >
            <Text size={3}>{t("faq_panel5_content8")}</Text>
            <Flex vertical>
              <Text size={3}>{t("faq_panel5_content5")}</Text>
              <img
                src={jurojin3}
                className="FAQPage__Collapse-image"
              />
            </Flex>
            <Flex vertical>
              <Text size={3}>
                {t("faq_panel5_content6_1")}
                <b>{t("faq_panel5_content6_2")}</b>
              </Text>
              <Text
                size={3}
                type="primary"
                underline
              >
                {
                  "https://fishhunter.info/statistics?playername=<PLAYER>&room=wpn"
                }
              </Text>
            </Flex>
            <img
              src={jurojin4}
              className="FAQPage__Collapse-image"
            />
            <Text size={3}>{t("faq_panel5_content9")}</Text>
          </Flex>
        </Flex>
      ),
    },
  ];
  return (
    <Flex
      className="FAQPage"
      justify="center"
      vertical
      gap={32}
    >
      <Text size={5}>FAQ / {t("faq_title")}</Text>
      <Collapse
        items={items}
        accordion={true}
        expandIcon={expandIcon}
        openMotion={motion}
        className="FAQPage__Collapse"
      />
    </Flex>
  );
});

export default FAQPage;
